export default __webpack_public_path__ + "static/media/plug-connected.49dd2371.svg";